/**
 * OS DOIS TOTAIS DA CROMATOGRAFIA — calculados, nunca digitados.
 *
 *   Total de Gases                 = H₂ + O₂ + N₂ + CH₄ + CO + CO₂ + C₂H₄ + C₂H₆ + C₂H₂
 *   Total de Gases Combustíveis    = H₂ + CH₄ + CO + C₂H₄ + C₂H₆ + C₂H₂
 *                                    (O₂, N₂ e CO₂ não são combustíveis)
 *
 * Um lugar só, usado pela tela (mostra ao vivo), pelo servidor (grava ao
 * salvar) e pelo gerador do laudo — digitados à mão, os totais erravam a soma.
 *
 * Valor abaixo do limite de quantificação ("< 5") não foi quantificado e entra
 * como zero na soma; campo vazio ou sem número também não soma.
 */

export const GASES_DO_TOTAL = ["h2", "o2", "n2", "ch4", "co", "co2", "c2h4", "c2h6", "c2h2"] as const;
export const GASES_COMBUSTIVEIS = ["h2", "ch4", "co", "c2h4", "c2h6", "c2h2"] as const;

/** As chaves que a tela mostra como calculadas (somente leitura). */
export const CHAVES_CALCULADAS = new Set(["total", "totalCombustiveis"]);

function lerParaSoma(bruto: unknown): number | null {
  if (bruto === null || bruto === undefined) return null;
  const texto = String(bruto).trim();
  if (!texto || texto.startsWith("<")) return null;
  const n = Number(texto.replace(/[>≥≤\s]/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function somar(valores: Record<string, unknown>, chaves: readonly string[]): string {
  let soma = 0;
  let algum = false;
  for (const c of chaves) {
    const n = lerParaSoma(valores?.[c]);
    if (n === null) continue;
    soma += n;
    algum = true;
  }
  if (!algum) return "";
  // Sem separador de milhar (é assim que os gases são digitados), vírgula decimal.
  return soma.toLocaleString("pt-BR", { maximumFractionDigits: 2, useGrouping: false });
}

/** Os dois totais a partir dos gases da seção. Vazio quando nenhum gás foi lançado. */
export function calcularTotaisGases(valores: Record<string, unknown>): {
  total: string;
  totalCombustiveis: string;
} {
  return {
    total: somar(valores, GASES_DO_TOTAL),
    totalCombustiveis: somar(valores, GASES_COMBUSTIVEIS),
  };
}
